import { render, staticRenderFns } from "./FlowTasklist.vue?vue&type=template&id=822d63d2&"
import script from "./FlowTasklist.vue?vue&type=script&lang=js&"
export * from "./FlowTasklist.vue?vue&type=script&lang=js&"
import style0 from "./FlowTasklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports